<gen-category-menu
  [node]="node$ | async"
  [navAriaLabel]="'navigation.categoryNavLabel' | cxTranslate"
></gen-category-menu>
